module.exports = {"510923100":"蓬莱镇","510923101":"隆盛镇","510923102":"回马镇","510923103":"天保镇","510923104":"河边镇","510923105":"卓筒井镇","510923106":"玉峰镇","510923107":"象山镇","510923108":"金元镇","510923200":"通仙乡","510923202":"智水乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510923.json
// module id = 2321
// module chunks = 0